import { useEffect, useRef } from 'react'

import {
  AnnotationReplyCreatedSubscription,
  AnnotationReplyDeletedSubscription,
  AnnotationReplyEditedSubscription,
  AnnotationReplyReadSubscription,
  useAnnotationReplyCreatedSubscription,
  useAnnotationReplyDeletedSubscription,
  useAnnotationReplyEditedSubscription,
  useAnnotationReplyReadSubscription,
} from '@sketch/gql-types'

type OnSubscription =
  | ['created', AnnotationReplyCreatedSubscription]
  | ['deleted', AnnotationReplyDeletedSubscription]
  | ['edited', AnnotationReplyEditedSubscription]
  | ['marked-as-read', AnnotationReplyReadSubscription]

const useCommentSubscriptions = (
  shareIdentifier: string,
  previewIdentifier?: string,
  onData?: (...params: OnSubscription) => void
) => {
  const variables = previewIdentifier
    ? { previewIdentifier }
    : { shareIdentifier }

  const onSubscriptionRef = useRef(onData)
  useEffect(() => {
    onSubscriptionRef.current = onData
  }, [onData])

  useAnnotationReplyCreatedSubscription({
    variables,
    onData: ({ data: subscriptionData }) => {
      subscriptionData.data &&
        onSubscriptionRef.current?.('created', subscriptionData.data)
    },
  })

  useAnnotationReplyDeletedSubscription({
    variables,
    onData: ({ data: subscriptionData }) =>
      subscriptionData.data &&
      onSubscriptionRef.current?.('deleted', subscriptionData.data),
  })

  useAnnotationReplyEditedSubscription({
    variables: { shareIdentifier },
    onData: ({ data: subscriptionData }) =>
      subscriptionData.data &&
      onSubscriptionRef.current?.('edited', subscriptionData.data),
  })

  useAnnotationReplyReadSubscription({
    variables,
    onData: ({ data: subscriptionData }) =>
      subscriptionData.data &&
      onSubscriptionRef.current?.('marked-as-read', subscriptionData.data),
  })
}

export default useCommentSubscriptions
